import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class SharedCaseManagementService {
  caseView = new BehaviorSubject<string | null>(null);
  caseView$ = this.caseView.asObservable();
   
  case = new BehaviorSubject<string | null>(null);
  case$ = this.case.asObservable();
  
  private readonly fcmToken = new BehaviorSubject<string | null>(null);
  fcmToken$ = this.fcmToken.asObservable();
  
  notificationClicked = new BehaviorSubject<string | null>(null);
  notificationClicked$ = this.notificationClicked.asObservable();

  private readonly addNotification = new BehaviorSubject<any >(null);
  addNotification$ = this.addNotification.asObservable();

  private readonly isRedNotificationDotVisible = new BehaviorSubject<boolean>(false);
  isRedNotificationDotVisible$ = this.isRedNotificationDotVisible.asObservable();

  private readonly isBellIconVisible = new BehaviorSubject<boolean>(true);
  isBellIconVisible$ = this.isBellIconVisible.asObservable();

  changeCaseView(caseView: string | null): void {
    this.caseView.next(caseView);
  }
  
  changeCase(case1: any) {
    this.case.next(case1);
  }
  changeFcmToken(token: string | null): void {
    this.fcmToken.next(token);
  }
  updateNotification(notification: any) {
    this.addNotification.next(notification);
  }
  changeNotification(notification: any) {
    this.notificationClicked.next(notification);
  }
  changeBellIconVisibility(isVisible: boolean): void {
    this.isBellIconVisible.next(isVisible);
  }
  getProgressBarStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    if (timeConsumedInPercentage >= 0 && timeConsumedInPercentage < 65.16) {
      return {
        'background-color': '#00C292',
        'border-radius': '10px 0 0 10px', // round left only
      };
    } else if (timeConsumedInPercentage >= 65.16 && timeConsumedInPercentage < 100) {
      return {
        // orange color
        'background-color': '#FFBD43',
        'border-radius': '10px 0 0 10px', // round left only 
      };
    } else {
      return {
        // red color
        'background-color': '#FF0021',
        'border-radius': '10px', // fully rounded 
      };
    }
  }

  getProgressBarContainerStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    if (timeConsumedInPercentage >= 0 && timeConsumedInPercentage < 65.16) {
      return {
        'border': '1px solid #ACECC3',
      };
    } else if (timeConsumedInPercentage >= 65.16 && timeConsumedInPercentage < 100) {
      return {
        'border': '1px solid #FFDBB2',
      };
    } else {
      return {
        'border': '1px solid #FFBDB2',
      };
    }
  }
  getProgressBackgroundStyles(timeConsumedInPercentage: number): { [key: string]: string } {
  if (timeConsumedInPercentage >= 0 && timeConsumedInPercentage < 65.16) {
    return {
      'background-color': '#F2FFF7', // light green
    };
  } else if (timeConsumedInPercentage >= 65.16 && timeConsumedInPercentage < 100) {
    return {
      'background-color': '#FFF9F2', // light orange
    };
  } else {
    return {
      'background-color': '#FFF4F2', // light red
    };
  }
}
  
  setRedNotificationDotVisibility(isVisible: boolean): void {
    this.isRedNotificationDotVisible.next(isVisible);
  }
  getRedNotificationDotVisibility(): boolean {
    return this.isRedNotificationDotVisible.getValue();
  }
}
